module.exports = __webpack_public_path__ + "static/book-3dc477563c760c5be5e8c8764153d1f5.svg";